import React, { useContext, useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import DeliveryAddress from './DeliveryAddress';
import DeliverySchedule from './DeliverySchedule';
import ReviewProduct from '../CartList/ReviewProduct';
import { collectionContext } from '../../App';
import { removeFromDatabaseCart } from '../../utilities/databaseManager';
import { getWindowDimensions, handleBack, handleNext, handleReset, removeFromCart, deliveryData} from '../../driver';
import Payment from '../Payment/Payment';

const steps = ['DELIVERY ADDRESS', 'DELIVERY SCHEDULE', 'REVIEW ORDER', 'MAKE PAYMENT'];

export default function VerticalLinearStepper({ cartData }) {
    const [activeStep, setActiveStep] = React.useState(0);
    const { value2 } = useContext(collectionContext);
    const [, setRefresh] = value2;
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [zip, setZip] = useState('');
    const [houseFlat, setHouseFlat] = useState('');
    const [street, setStreet] = useState('');
    const [landmark, setLandMark] = useState('');
    const [city, setCity] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [deliveryDate, setDeliveryDate] = useState(new Date());
    const td = name && email && zip && houseFlat && street && landmark && city && phoneNumber;

    

    const deliveryInfo = { name, email, zip, houseFlat, street, landmark, city, phoneNumber, deliveryDate, cartData };

    const listStepper = [
        <DeliveryAddress deliveryData={deliveryData(name, email, zip, houseFlat, street, landmark, city, phoneNumber, setName, setEmail, setZip, setHouseFlat, setStreet, setLandMark, setCity, setPhoneNumber)} />,
        <DeliverySchedule value={deliveryDate} setValue={setDeliveryDate} />,
        <ReviewProduct cartData={cartData} windowDimensions={windowDimensions} removeFromCart={removeFromCart} removeFromDatabaseCart={removeFromDatabaseCart} setRefresh={setRefresh} />,
        <Payment deliveryInfo={deliveryInfo} />
    ]

    return (
        <Box sx={{ maxWidth: '100%' }}>
            <Stepper activeStep={activeStep} orientation="vertical">
                {steps.map((step, index) => (
                    <Step key={index}>
                        <StepLabel
                            optional={
                                index === steps.length ? (
                                    <Typography variant="caption">Last step</Typography>
                                ) : null
                            }
                        >
                            {step}
                        </StepLabel>
                        <StepContent>
                            {
                                listStepper[index]
                            }
                            <Box sx={{ mb: 2 }}>
                                <div>

                                    {
                                        !(index === steps.length - 1) && <Button
                                            disabled={
                                                (!td && (index === 0) && true)
                                                ||
                                                ((cartData.length === 0 && (index === 2)) && true)}
                                            variant="contained"
                                            onClick={() => handleNext(setActiveStep)}
                                            sx={{ mt: 1, mr: 1 }}
                                        >
                                            {index === steps.length - 1 ? 'Finish' : 'Continue'}
                                        </Button>
                                    }

                                    <Button
                                        disabled={index === 0}
                                        onClick={() => handleBack(setActiveStep)}
                                        sx={{ mt: 1, mr: 1 }}
                                    >
                                        Back
                                    </Button>
                                </div>
                            </Box>
                        </StepContent>
                    </Step>
                ))}
            </Stepper>
            {activeStep === steps.length && (
                <Paper square elevation={0} sx={{ p: 3 }}>
                    <Typography>All steps completed - you&apos;re finished</Typography>
                    <Button onClick={() => handleReset(setActiveStep)} sx={{ mt: 1, mr: 1 }}>
                        Recheck
                    </Button>
                </Paper>
            )}
        </Box>
    );
}